<template>
  <custom-dialog width="1120px" :title="model.title" :visible="visible" v-on="$listeners" :appendToBody="true" >
    <div class="dialog-body">
      <el-table :size="allTableSize" :data="tableList">
        <el-table-column label="#" type="index" width="44"></el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.zlzqdw')">
          <template slot-scope="scope">
            <custom-select
              v-model="scope.row.rentalTermUnit"
              code="rental_term_unit"
              :placeholder="i18n.com_copy_up"
              :clearable="!!scope.$index"
              width="100%"
            ></custom-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.zu_lin_zhou_qi')" width="178">
          <template slot-scope="scope">
            <div>
              <el-input
                type="number"
                :min="0"
                v-model="scope.row.rentalTermMin"
                placeholder
                style="width: 70px"
              ></el-input>
              <div style="display: inline-block; margin: 0 6px; padding-top: 2px;">--</div>
              <el-input
                type="number"
                :min="0"
                v-model="scope.row.rentalTermMax"
                placeholder
                style="width: 70px"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.she_bei_lei_xing')" width="210">
          <template slot-scope="scope">
            <custom-select
              :multiple="true"
              v-model="scope.row.deviceBizType"
              code="dms_device_biz_type"
              :placeholder="i18n.com_select"
              width="100%"
            ></custom-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.zhi_fu_zhou_qi')" width="210">
          <template slot-scope="scope">
            <custom-select
              :multiple="true"
              v-model="scope.row.paymentPeriod"
              code="crm_payment_period"
              :placeholder="i18n.com_select"
              width="100%"
            ></custom-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.zhi_fu_jie_dian')">
          <template slot-scope="scope">
            <custom-select
              v-model="scope.row.paymentNode"
              code="payment_node"
              :placeholder="i18n.com_copy_up"
              :clearable="!!scope.$index"
              width="100%"
            ></custom-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm_step_manage_add_dialog.bi_zhong')">
          <template slot-scope="scope">
            <custom-select
              v-model="scope.row.currencyUnit"
              code="isynergy_cloud_currency"
              :placeholder="i18n.com_copy_up"
              :clearable="!!scope.$index"
              width="100%"
            ></custom-select>
          </template>
        </el-table-column>
        <el-table-column prop="partType" :label="$t('Common.com_handle')" width="90">
          <template slot-scope="scope">
            <el-button
              v-if="scope.$index > 0"
              type="text"
              size="small"
              @click="deleteRow(scope.$index)"
            >{{ $t('Common.com_delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="step-manage-add-btn" @click="addRow()">
        <div style="display: inline-block">
          <i class="icon icon-add"></i>
          <span>{{ $t('Common.com_add') }}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        paymentNode: '',
        currencyUnit: '',
        deviceBizType: [],
        paymentPeriod: [],
        rentalTermMax: '',
        rentalTermMin: '',
        rentalTermUnit: '',
      },
      tableList: [],
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.addRow();
      this.addRow();
      this.addRow();
    },
    // 新增方案行
    addRow: function () {
      const form = JSON.parse(JSON.stringify(this.form));
      if (!this.tableList.length) {
        form.currencyUnit = '¥';
        form.rentalTermUnit = 'M';
        form.paymentNode = '1';
      }
      this.tableList.push(form);
    },
    // 删除行
    deleteRow: function (index) {
      this.tableList.splice(index, 1);
    },
    // 确认保存
    confirm: function () {
      // 保证第一行要填写
      if (
        !this.tableList[0].rentalTermMin
        || !this.tableList[0].rentalTermMax
        || !this.tableList[0].deviceBizType.length
        || !this.tableList[0].paymentPeriod.length
      ) {
        this.$message.error(this.$t('crm_step_manage_add_dialog.qtxzlfa'));
        return;
      }
      // 每行填写保证字段完整
      const hasOneList = this.tableList.filter(
        t => t.rentalTermMin
          || t.rentalTermMax
          || t.deviceBizType.length
          || t.paymentPeriod.length
      );
      const hasAllList = this.tableList.filter(
        t => t.rentalTermMin
          && t.rentalTermMax
          && t.deviceBizType.length
          && t.paymentPeriod.length
      );
      if (hasAllList.length !== hasOneList.length) {
        this.$message.error(this.$t('crm_step_manage_add_dialog.qjxxtxwz'));
        return;
      }
      // 验证租赁周期
      const errLen = hasAllList.filter(
        t => Number.parseInt(t.rentalTermMin, 10)
            >= Number.parseInt(t.rentalTermMax, 10)
          || Number.parseInt(t.rentalTermMin, 10) === 0
      );
      if (errLen.length) {
        this.$message.error(this.$t('crm_step_manage_add_dialog.zlzqqjgscw'));
        return;
      }
      // 格式化'默认同上'
      const formList = this.$formatCopyUp(hasAllList, [
        'currencyUnit',
        'rentalTermUnit',
        'paymentNode',
      ]);
      // deviceBizType
      let payList = [];
      formList.forEach((item) => {
        const arr = item.paymentPeriod.map(t => Object.assign({}, item, { paymentPeriod: t })
        );
        payList = [...payList, ...arr];
      });
      let bizList = [];
      payList.forEach((item) => {
        const arr = item.deviceBizType.map(t => Object.assign({}, item, { deviceBizType: t })
        );
        bizList = [...bizList, ...arr];
      });
      // 提交接口
      this.$postJSON(apis.GoodsSkuAdd, {
        goodsId: this.model.data.goodsId,
        skuList: bizList,
      }).then(() => {
        this.visible = false;
        this.$emit('success', bizList);
      });
    },
  },
};
</script>

<style lang="scss">
.step-manage-add-btn {
  cursor: pointer;
  margin-top: 8px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #f6f7fb;
  border: 1px dashed rgba(53, 184, 224, 0.3);
  color: #495057;
  font-size: 12px;
  .icon {
    float: left;
    color: #0d9ae0;
    margin-right: 4px;
  }
}
</style>
